<app-dialog>
  <app-dialog-title>{{ objectDisplayName }}</app-dialog-title>
  @if (!selectionOnly) {
    <button
      app-dialog-header-button
      mat-icon-button
      (click)="save()"
      class="mat-icon-button-primary-color"
    >
      <mat-icon>check</mat-icon>
    </button>
  }
  <button
    app-dialog-header-button
    mat-icon-button
    (click)="close()"
    class="mat-icon-button-error-color"
  >
    <mat-icon>undo</mat-icon>
  </button>
  <div mat-dialog-content>
    <div class="row">
      <div
        [class.col-md-6]="!selectionOnly"
        [class.col-md-12]="selectionOnly"
        [hidden]="!addAllowed"
      >
        <!-- Left DataTable: Search for Objects to add -->
        <h2>{{ addListTitle }}</h2>
        <smd-datatable
          #searchList
          [paginated]="true"
          [responsive]="true"
          [disableLinks]="true"
          [headerRowIcon]="searchListHeaderIcon"
          [headerRowIconTooltip]="searchListHeaderIconTooltip"
          [eachRowIcon]="MoveRightIcon"
          (onAddView)="onAddView.emit($event)"
          [remoteSpecialMarkedObjectIDs]="currentlySelectedValues"
          [remoteSpecialMark]="HideMark"
          [remoteSpecialIcon]="MoveLeftIcon"
          (onRowsReloaded)="onSearchListRowsReloaded($event)"
          (onRowIconClicked)="searchListRowClick($event)"
          (onError)="handleError($event)"
        >
          <smd-datatable-header
            [actionBarConfigs]="searchListActionBar"
            [initFilterValue]="initFilterValue"
            [showActionBarSpacer]="false"
          ></smd-datatable-header>
        </smd-datatable>
      </div>
      <div [class.col-md-6]="addAllowed" [class.col-md-12]="!addAllowed" [hidden]="selectionOnly">
        <!-- Right DataTable: Already selected Objects -->
        <div class="col-header">
          <h2>{{ getCaughtObservable(attributeLabel) | async }}</h2>
          <span class="localSwitch">
            <mat-slide-toggle color="primary" [(ngModel)]="ShowChanges">
              <language key="ResourceMultivalueShowChanges" defaultValue="Show Changes"></language>
            </mat-slide-toggle>
          </span>
        </div>
        <smd-datatable
          #valuesList
          [paginated]="true"
          [responsive]="true"
          [disableLinks]="true"
          [hidden]="ShowChanges"
          [mergeRemoteAndLocal]="true"
          [additionalLoadedAttributes]="displayNameAttributeArray"
          [headerRowIcon]="valuesListHeaderIcon"
          [headerRowIconTooltip]="valuesListHeaderIconTooltip"
          [eachRowIcon]="valuesListIcon"
          (onAddView)="onAddView.emit($event)"
          [remoteSpecialIcon]="AddIcon"
          [remoteSpecialMark]="HideMark"
          (onRowIconClicked)="valueListRowClick($event)"
          (onError)="handleError($event)"
        >
          <smd-datatable-header
            [actionBarConfigs]="valuesListActionBar"
            [showActionBarSpacer]="false"
          ></smd-datatable-header>
        </smd-datatable>
        <smd-datatable
          #changesList
          [paginated]="true"
          [responsive]="true"
          [disableLinks]="true"
          [hidden]="!ShowChanges"
          [additionalLoadedAttributes]="displayNameAttributeArray"
          [headerRowIcon]="changesListHeaderIcon"
          [headerRowIconTooltip]="changesListHeaderIconTooltip"
          [localRowModels]="changesRowModels"
          (onAddView)="onAddView.emit($event)"
          (onRowIconClicked)="changesListRowClick($event)"
          [ShowLocal]="true"
          (onError)="handleError($event)"
        >
          <smd-datatable-header [showActionBarSpacer]="false"></smd-datatable-header>
        </smd-datatable>
      </div>
    </div>
  </div>
</app-dialog>
